/*
* @Author: zhengxiaowen
* @Date: 2018-08-21 11:46:27
* @Last Modified by: zhengxiaowen
* @Last Modified time: 2019-04-24 16:14:26
*/


import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'

Vue.use(VueCompositionAPI)

import App from './App'
import Vuex from 'vuex'

import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import { sync } from 'vuex-router-sync'
import './assets/iconfont/iconfont.css'
import './assets/style/style.less'
import '@/assets/css/reset.css'
import '@/assets/css/common.css'
import '@/assets/css/base.css'
import VueBetterScroll from 'vue2-better-scroll'
import moment from 'moment'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

import lodash from 'lodash'


import routes from './common/config/routerCommon'
import store from './common/store/StoreCommon'
import nativeApi from './common/tool/sdk2/nativeApi'

import '@vant/touch-emulator';
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);




import vuescroll from "vuescroll";
import "vuescroll/dist/vuescroll.css";
Vue.use(vuescroll);

window._ = lodash
window.moment = moment
window['GoogleAnalyticsObject'] = 'ga'

import PdfJSView from "./components/PdfJSView.vue"
Vue.component('PdfJSView', PdfJSView)

Vue.use(VueRouter)
Vue.use(VueBetterScroll)

Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)
Vue.use(AlertPlugin)


Vue.use(Vuex)
Vue.use(DatetimePlugin)
const router = new VueRouter({
mode: 'history',
routes
})

sync(store, router)
FastClick.attach(document.body)

Vue.config.productionTip = false

const history = window.sessionStorage
let isNative = history.isNative
history.clear()
history.isNative = isNative 
let historyCount = history.getItem('count') * 1 || 0
history.setItem('/', 0)
let isPush = false
let endTime = Date.now()
let methods = ['push', 'go', 'replace', 'forward', 'back']

document.addEventListener('touchend', () => {
endTime = Date.now()
})

import RSAUtil from "@/utils/RSAUtil"
import { fetch } from "@/page/index";
import { resolveApprovalRouteName, buildApprovalDetailQuery } from '@/page/srm/pendingApproval/utils/approvalRouteMap';
import { isLoginRoute, isLoggedIn, srmLoginRedirect } from '@/utils/authRoute';


const FEISHU_TOKEN_PATH = '/feishuToken';

methods.forEach(key => {
let method = router[key].bind(router)
router[key] = function (...args) {
isPush = true
method.apply(null, args)
}
})

function handleSingleLogin(item) {
let _host = window.location.host;
_host = _host.indexOf(":") !== -1 ? _host.substring(0, _host.indexOf(":")) : _host;
_host = "http://" + _host;

let _params = {
userName: item.userName,
verificationCode: item.verificationCode,
domain: _host,
lan: "CN"
}
handleLogin(_params, item)
}
function handleLogin(param, item) {
fetch.baseLookupTypeService_findDic().then(res=>{
localStorage.setItem("lookupValues", JSON.stringify(res.data));
store.commit('SET_DIC_CODES', res.data)

fetch.login(param).then((res) => {
localStorage.userInfo = JSON.stringify(res.data);
store.commit('INIT_USER_INFO')

fetch.baseUsersService_getTaskIdByBpmListId({bpmListId: item.bpmListId, userName: item.userName}).then(r => {
redirectTo({
...item,
taskId: r.data.taskId
})
})

}).catch((err) => {
console.log(err)
})
})
}
function redirectTo(item) {
const name = resolveApprovalRouteName(item.processDefinitionKey)
if (!name) return
router.push({
name,
query: buildApprovalDetailQuery(item),
})
}

router.beforeEach(function (to, from, next) {
console.log('[router.beforeEach] to.path=' + to.path + ', from.path=' + from.path);



const isBindWxAction = to.query.action === 'bindWx' || to.query.state === 'bindWx'
if (isBindWxAction && to.name === 'mine') {
console.log('[router.beforeEach] 是绑定微信场景');
next()
return
}
















if (to.meta.keepAlive !== false) {
to.meta.keepAlive = true
}

const toIndex = history.getItem(to.path)
const fromIndex = history.getItem(from.path)

const normalizedPath = (to.path || '').replace(/\/$/, '') || '/'
console.log('[router.beforeEach] normalizedPath=' + normalizedPath);

if (normalizedPath === '/login') {
console.log('[router.beforeEach] 是/login，重定向到/srmLogin');
next({ ...srmLoginRedirect(to), replace: true })
return
}


if (normalizedPath === FEISHU_TOKEN_PATH) {
console.log('[router.beforeEach] 是feishuToken页面，直接放行');
next()
return
}



const userInfoStr = localStorage.getItem('userInfo')
const hasUserInfo = userInfoStr && JSON.parse(userInfoStr).userName
console.log('[router.beforeEach] hasUserInfo=' + hasUserInfo + ', userInfoStr=' + (userInfoStr ? '存在' : '不存在'));

if (hasUserInfo && (normalizedPath === '/TabPage' || normalizedPath.startsWith('/TabPage/') ||
normalizedPath === '/home' || normalizedPath === '/mine' || normalizedPath === '/message' || normalizedPath === '/approval')) {
console.log('[router.beforeEach] 有userInfo且是主页相关页面，直接放行');
next()
return
}

const loggedIn = isLoggedIn()
console.log('[router.beforeEach] isLoggedIn=' + loggedIn);

if (!isLoginRoute(to.path) && !loggedIn) {
console.log('[router.beforeEach] 未登录且不是登录页，重定向到/srmLogin');
next({ ...srmLoginRedirect(to), replace: true })
return
}

console.log('[router.beforeEach] 正常放行');
store.commit('updateLoadingStatus', { isLoading: true })
console.log(toIndex);

let obj = _.find(routes, function (item) { return item.name === to.name })

store.commit('SET_ROUTER', obj)

if (store.state.system.isNative) {
if (to.path === '/' && from.path !== '/') {
nativeApi.nativeFN.RNGoBack()
}

}


if (toIndex) {
if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || (toIndex === '0' && fromIndex === '0')) {
store.commit('updateDirection', { direction: 'forward' })
} else {

if (!isPush && (Date.now() - endTime) < 377) {
store.commit('updateDirection', { direction: '' })
} else {
store.commit('updateDirection', { direction: 'reverse' })
}
}
} else {
++historyCount
history.setItem('count', historyCount)
to.path !== '/' && history.setItem(to.path, historyCount)
store.commit('updateDirection', { direction: 'forward' })
}

if (/\/http/.test(to.path)) {
let url = to.path.split('http')[1]
window.location.href = `http${url}`
} else {
next()
}
})

router.afterEach(function (to) {
isPush = false
store.commit('updateLoadingStatus', { isLoading: false })




})

/* eslint-disable no-new */
new Vue({
store,
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js